/* eslint-disable*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DtpAccordionGroup, DtpAccordionPanel, DtpPanel } from 'dtp-react-components';
import { Input, Button, Grid, Table, SimpleGrid } from '../../../components';
import Masks from '../../../utils/masks';
import { doGet, trataMensagensErro } from '../../../utils/requests';
const jssLinhaCalculadora = {display:'flex', padding:'0 30px 0 15px', marginBottom: '3px'};
const jssColEsquerdaCalculadora={display:'inline-block'};
const jssFillerLinhaCalculadora= {
  display:'inline-block',
  flexGrow:'1',
  borderBottomStyle: 'dotted', 
  borderBlockWidth: '1px',
  height: '17px',
  margin: '0 10px 0 7px',
}
const jssColDireitaCalculadora= {display:'inline-block'};
const TIPO_MENSAGEM_DEFESA_EXTRAORDINARIA = '15';

class CalculadoraPagamento extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInicialState();
   /* this.state = {
      acrescimosLegaisPesquisa: {
        dataVencimento: null,
        dataPagamento: null,
        valorBaseCalculo: null,
      },
      listaAcrescimosLegaisResultado: [],
      valorTotal: null,
    };*/
  }
  getInicialState = () =>({
    retornoCalculado: false,
    dataVencimento: this.props.infoPagamento.dataVencimento, 
    valorCompensacao: this.props.infoPagamento.valorCompensacao,
    dataPagamento: null,
    valorParcial: null,
    valorParcialNumber: this.props.valorParcial,
    valorTotal: null,
    valorBaseCalculo: this.props.infoPagamento.valorCompensacao,
    listaAcrescimosLegaisResultado: [],
  })
  habilitarBotao = () => {
    let valido = false;
    if (this.state.dataVencimento && this.state.dataPagamento && this.state.valorBaseCalculo) {
      valido = true;
    }
    return valido;
  }
  handleTextChange = (changeObj, name) => {
    if(!this.state.retornoCalculado){
      this.setState({
        ...this.state,
        [name]: changeObj.value,
      });
    }
    //if(name==='valorParcial'){
    //  this.setState({valorFaltantePagamento: this.calculaDiferencaEntreValorTotalPagamentoEValorParcial(this.state.valorTotal)})
    //}
  }
  formatarValorMonetario(valor){
    let retorno = valor;
    if (retorno.length > 0 &&(retorno.indexOf('_') !== -1)) {
      retorno = retorno.toString().replace('_', '');
    }
    retorno = retorno.toString().replace(/\D/g, '');
    retorno = retorno.toString().replace(/(\d)(\d{11})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{8})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{5})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{2})$/, '$1,$2');
    return retorno;  
  }
  handleKeyUp = (e) => {
    let retorno = e.target.value;
    retorno = this.formatarValorMonetario(retorno);
    e.target.value = retorno;
    return retorno;
  }
  handleCalcular = () => {
    if (this.state.dataVencimento && this.state.dataPagamento && this.state.valorBaseCalculo) {
      const dataVencimento = this.state.dataVencimento.replace(/\//g, '').replace(/_/g, '');
      const dataPagamento = this.state.dataPagamento.replace(/\//g, '').replace(/_/g, '');
      const objValorBaseCalculo = this.state.valorBaseCalculo;
      
      let mensagemErro = null;


      if (this.props.infoPagamento && this.props.infoPagamento.cronogramaPagamentoTO && this.props.infoPagamento.cronogramaPagamentoTO.dataPrazoDefesa ){
        if(moment(dataPagamento, 'DD/MM/YYYY').toDate() > moment(this.props.infoPagamento.cronogramaPagamentoTO.dataPrazoDefesa, 'DD/MM/YYYY').toDate()){
          mensagemErro = 'A data de pagamento deve ser menor ou igual que a data limite de defesa.';
          //trataMensagensErro(['A data de pagamento deve ser menor ou igual que a data limite de defesa.']);
          //valido = false;
        }
      }

      if(!this.props.opcaoNovaMensagem ||
        (this.props.opcaoNovaMensagem && this.props.opcaoNovaMensagem !== TIPO_MENSAGEM_DEFESA_EXTRAORDINARIA)) {
        if (moment(dataPagamento, 'DD/MM/YYYY').toDate() <= moment(dataVencimento, 'DD/MM/YYYY').toDate()) {
          mensagemErro = 'A data de pagamento deve ser maior que a data de vencimento.';
          // trataMensagensErro(['A data de pagamento deve ser maior que a data de vencimento.']);
        }
      }
 
      if(!mensagemErro){
        let url = `acrescimos-legais/${dataVencimento}/${dataPagamento}/${objValorBaseCalculo}`;
        if (this.props.opcaoNovaMensagem === TIPO_MENSAGEM_DEFESA_EXTRAORDINARIA) {
          url = `acrescimos-legais/${dataVencimento}/${dataPagamento}/${objValorBaseCalculo}/${this.props.opcaoNovaMensagem}`;
        }
        doGet(url, this.trataSucessoResponse);
      } else  {
        trataMensagensErro([mensagemErro]);
      }
    
    }
  }
  calculaDiferencaEntreValorTotalPagamentoEValorParcial = (valorTotalPagamento) => {

    if (this.state.valorParcialNumber){
      return   valorTotalPagamento - this.state.valorParcialNumber;
    }
    const valorParcialFormatado = (this.state.valorParcial === null ||
      this.state.valorParcial === undefined) ? 0.0 :
      this.state.valorParcial.replace('.', '').replace(',', '.');
      const resultado = valorTotalPagamento - parseFloat(valorParcialFormatado);
    
    return resultado;
  }
  parseValorParcial = () =>{
    const valorParcialFormatado = (this.state.valorParcial === null ||
      this.state.valorParcial === undefined) ? 0.0 :
      this.state.valorParcial.replace('.', '');
      const resultado = parseFloat(valorParcialFormatado);
    return resultado;
  }
  trataSucessoResponse = (response) => {
    if (response.data) {
      this.setState({
        valorTotal: response.data.valorTotalPagamento,
        valorFaltantePagamento: this.calculaDiferencaEntreValorTotalPagamentoEValorParcial([response.data.valorTotalPagamento]), 
        valorJuros: response.data.valorTotalJuros,
        valorMulta: response.data.valorTotalMulta,
        listaAcrescimosLegaisResultado: [response.data], 
        retornoCalculado:true,
      });
    }
    if(this.props.incluirJuroseMultaNaMensagem){
      this.props.incluirJuroseMultaNaMensagem(response.data,this.state.dataPagamento);
    }
  }
  recuperarColunasDescritivoMulta = () => {
    const cabecalhoTabela = [{
      id: 'diasAtraso',
      label: 'Dias de Atraso',
    }, {
      id: 'multaPorDia',
      label: '% Multa (diária)',
      dataFormat: this.formatarPercentual,
    }, {
      id: 'multaAcumulada',
      label: '% Multa (acumulada)',
      dataFormat: this.formatarPercentual,
    }, {
      id: 'valorTotalMulta',
      label: 'Valor Total Multa',
      dataFormat: this.formatarValor,
    }];
    return cabecalhoTabela;
  }
  recuperarColunasDescritivoJuroSelic = () => {
    const cabecalhoTabela = [{
      id: 'listaMeAnoSelicAcumulada',
      label: 'Meses Considerados',
      dataFormat: this.formatarMesesConsiderados,
    }, {
      id: 'selicAcumulada',
      label: '% Selic Acumulada',
      dataFormat: this.formatarPercentual,
    }, {
      id: 'valorTotalJuroSelicAcumulada',
      label: 'Valor Total da Selic Acumulada',
      dataFormat: this.formatarValor,
    }];
    return cabecalhoTabela;
  }
  recuperarColunasDescritivoJuroFixo = () => {
    const cabecalhoTabela = [{
      id: 'juroFixo',
      label: '% Juro Fixo',
      dataFormat: this.formatarPercentual,
    }, {
      id: 'valorTotalJuroFixo',
      label: 'Valor Total do Juro Fixo',
      dataFormat: this.formatarValor,
    }];
    return cabecalhoTabela;
  }
  recuperarColunasCalculoFinal = () => {
    const cabecalhoTabela = [{
      id: 'dataVencimento',
      label: 'Data de Vencimento',
      dataFormat: this.formatarData,
    }, {
      id: 'dataPagamento',
      label: 'Data de Pagamento',
      dataFormat: this.formatarData,
    }, {
      id: 'valorBaseCalculo',
      label: 'Valor Base de Cálculo',
      dataFormat: this.formatarValor,
    }, {
      id: 'valorTotalMulta',
      label: 'Valor Total da Multa',
      dataFormat: this.formatarValor,
    }, {
      id: 'valorTotalJuros',
      label: 'Valor Total de Juros',
      dataFormat: this.formatarValor,
    }, {
      id: 'valorTotalPagamento',
      label: 'Valor Total de Pagamento',
      dataFormat: this.formatarValor,
    }];
    return cabecalhoTabela;
  }
  formatarValor = (valor) => {
    let valorFormatado = '0.0';
    if (valor) {
      const formato = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
        style: 'currency',
        currency: 'BRL',
      };
      valorFormatado = valor.toLocaleString('pt-BR', formato);
    }
    return valorFormatado;
  };
  formatarPercentual = (valor) => {
    let valorFormatado = '0.0';
    if (valor) {
      const formato = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
      };
      valorFormatado = valor.toLocaleString('pt-BR', formato);
    }
    return valorFormatado;
  };
  formatarMesesConsiderados = (lista) => {
    let listaMesesConsideradosFormatado = '--------';
    if (lista) {
      if (lista.length === 1) {
        listaMesesConsideradosFormatado = lista;
      } else {
        listaMesesConsideradosFormatado = lista[0].concat(' a ').concat(lista[lista.length - 1]);
      }
    }
    return listaMesesConsideradosFormatado;
  };
  formatarData = (data) => {
    let dataFormatada = '';
    if (data) {
      dataFormatada = moment(data).format('DD/MM/YYYY');
    }
    return dataFormatada;
  };
  render() {
    const options = {
      withoutNoDataText: true,
    };
    const formatoMoeda = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 3,
      style: 'currency',
      currency: 'BRL',
    };

    //console.log('AQUI',this.props.infoPagamento);
   
    return (
      <SimpleGrid title="" icon="">
      <DtpPanel title='Acréscimos Legais'>
      {/* <DtpAccordionGroup>
          <DtpAccordionPanel
            headingId="calculo"
            panelId="calculo-acrescimos-legais"
            icon="ico-calc"
            title="Calculadora de Acréscimos Legais"
            collapsed={false}
            collapse={false}
          >*/}
            {this.props.mostrarCamposAdicionais && 
            <div className="row">
              <Grid cols="4">
                <Input
                  mask={Masks.date}
                  label="Data de Vencimento Original"
                  readOnly
                  onChange={e => this.handleTextChange(e, 'dataVencimento')}
                  value={this.state.dataVencimento}
                />
              </Grid>
              <Grid cols="4">
                <Input
                  currency
                  readOnly
                  showMask={false}
                  label="Valor da compensação"
                  maxLength="12"                 
                  value={this.state.valorCompensacao}
                  onChange={e => this.handleTextChange(e, 'valorCompensacao')}
                  onKeyUp={e => this.handleKeyUp(e)}
                />
              </Grid>
          
            <Grid cols="4">
              <Input
                currency
                showMask={false}
                label="Valor parcial pago"
                maxLength="12"
                value={this.state.valorParcial}
                onChange={e => this.handleTextChange(e, 'valorParcial')}
                onKeyUp={e => this.handleKeyUp(e)}
              />
            </Grid>
          </div>}
            <div className="row">
              <Grid cols="4">
                  <Input
                    mask={Masks.date}
                    label="Data efetiva do Pagamento"
                    required
                    value={this.state.dataPagamento}
                    onChange={e => this.handleTextChange(e, 'dataPagamento')}
                  />
                </Grid>
                <Grid cols="3">
                {!this.state.retornoCalculado ?
                <Button
                  className="dtp-primary right"
                  disabled={!this.habilitarBotao}
                  title="Calcular"
                  hint="Calcular Acréscimos Legais"
                  onClick={this.handleCalcular}
                /> :
                <Button
                  className="right"
                  disabled={!this.habilitarBotao}
                  title="Reiniciar"
                  hint="Calcular Acréscimos Legais"
                  onClick={() => {
                    this.setState(this.getInicialState()); 
                    if(this.props.incluirJuroseMultaNaMensagem){
                      this.props.incluirJuroseMultaNaMensagem(null,null);
                    };}}
                />}
              </Grid>
            </div>
            {this.state.retornoCalculado &&
            <div>
            <div className="row" style={jssLinhaCalculadora}>
              <div style={jssColEsquerdaCalculadora}>Vencimento:</div>
              <div style={jssFillerLinhaCalculadora}></div>
              <div style={jssColDireitaCalculadora}>{this.state.dataVencimento}</div>
            </div>
            <div className="row" style={jssLinhaCalculadora}>
              <div style={jssColEsquerdaCalculadora}>Valor da compensação:</div>
              <div style={jssFillerLinhaCalculadora}></div>
              <div style={jssColDireitaCalculadora}>{this.state.valorCompensacao.toLocaleString('pt-BR', formatoMoeda)}</div>
            </div>
            <div className="row" style={jssLinhaCalculadora}>
              <div style={jssColEsquerdaCalculadora}>Multa calculada para o pagamento em {this.state.dataPagamento}:</div>
              <div style={jssFillerLinhaCalculadora}></div>
              <div style={jssColDireitaCalculadora}>{this.state.valorMulta.toLocaleString('pt-BR', formatoMoeda)} </div>
            </div>
            <div className="row" style={jssLinhaCalculadora}>
              <div style={jssColEsquerdaCalculadora}>Juros calculados para o pagamento em {this.state.dataPagamento}:</div>
              <div style={jssFillerLinhaCalculadora}></div>
              <div style={jssColDireitaCalculadora}>{this.state.valorJuros.toLocaleString('pt-BR', formatoMoeda)} </div>
            </div>
            <div className="row" style={jssLinhaCalculadora}>
              <div style={jssColEsquerdaCalculadora}>Valor total a ser transferido até {this.state.dataPagamento}:</div>
              <div style={jssFillerLinhaCalculadora}></div>
              <div style={jssColDireitaCalculadora}> {this.state.valorTotal.toLocaleString('pt-BR', formatoMoeda)} </div>
            </div>
            {(this.state.valorParcialNumber ||  this.state.valorParcial )&&
            <div className="row" style={jssLinhaCalculadora}>
              <div style={jssColEsquerdaCalculadora}>Valor parcial pago:</div>
              <div style={jssFillerLinhaCalculadora}></div>
              <div style={jssColDireitaCalculadora}> {this.state.valorParcialNumber ? this.state.valorParcialNumber.toLocaleString('pt-BR', formatoMoeda) : this.state.valorParcial} </div>
            </div>}
            {(this.state.valorParcialNumber ||  this.state.valorParcial )&&
            <div className="row" style={jssLinhaCalculadora}>
              <div style={jssColEsquerdaCalculadora}>Valor faltante para completar o pagamento:</div>
              <div style={jssFillerLinhaCalculadora}></div>
              <div style={jssColDireitaCalculadora}> {this.state.valorFaltantePagamento.toLocaleString('pt-BR', formatoMoeda)} </div>
            </div>}  
            </div>   
            }         
        {/*  </DtpAccordionPanel>
        </DtpAccordionGroup>*/}
        </DtpPanel>
      </SimpleGrid>
    );
  }
}
CalculadoraPagamento.propTypes = {
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  incluirJuroseMultaNaMensagem: PropTypes.func.isRequired,
  opcaoNovaMensagem: PropTypes.number.isRequired,
};
export default CalculadoraPagamento;


// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/templates/CalculadoraPagamento.jsx